import React from "react";
import { Button } from "./ui/button";

const Hero = () => {
  const [videoLoaded, setVideoLoaded] = React.useState(false);

  React.useEffect(() => {
    // Delay video loading to prioritize LCP (Text and Images)
    // Increased to 3.5s to ensure mobile LCP finishes first
    const timer = setTimeout(() => setVideoLoaded(true), 3500);
    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative flex items-center justify-center overflow-hidden bg-slate-900"
      style={{
        width: "100vw",
        height: "100dvh",
        margin: 0,
        padding: 0,
        position: "relative",
      }}
    >
      {/* ✅ High-Performance LCP Image (Real IMG tag loads faster than CSS background) */}
      <div className="absolute inset-0 z-0">
        <picture>
          <source media="(max-width: 768px)" srcSet="/img/hero-bg-mobile.webp" />
          <img
            src="/img/hero-bg.webp"
            alt="Business Technology Background"
            fetchPriority="high"
            loading="eager"
            className={`w-full h-full object-cover transition-opacity duration-500 ${videoLoaded ? 'opacity-0' : 'opacity-100'}`}
          />
        </picture>
      </div>



      {/* ✅ Optimized Video Background (Self-Hosted for 100% Performance) */}
      <div
        className="absolute inset-0 z-0 overflow-hidden"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {videoLoaded && (
          <>
            {/* ✅ Desktop Video (Local - Lazy Start) */}
            <video
              ref={(el) => {
                if (el) {
                  el.volume = 0;
                  setTimeout(() => el.play().catch(() => { }), 2000); // 2s delay
                }
              }}
              loop
              muted
              playsInline
              preload="none"
              poster="/img/hero-bg.webp"
              className="hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full object-cover"
            >
              <source src="/img/hero-video.mp4" type="video/mp4" />
            </video>

            {/* ✅ Mobile Video (Local - Lazy Start) */}
            <video
              ref={(el) => {
                if (el) {
                  el.volume = 0;
                  setTimeout(() => el.play().catch(() => { }), 2000); // 2s delay
                }
              }}
              loop
              muted
              playsInline
              preload="none"
              poster="/img/hero-bg.webp"
              className="block md:hidden absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full object-cover"
            >
              <source src="/img/hero-video-mobile.mp4" type="video/mp4" />
            </video>

            {/* 🛑 Backup: Vimeo (Commented out for performance) */}
            {/* 
            <iframe
              className="hidden md:block"
              src="https://player.vimeo.com/video/1134204471?autoplay=1&loop=1&muted=1&controls=0&background=1"
              title="Hero Background Video"
              frameBorder="0"
              allow="autoplay; fullscreen"
              style={{
                position: "absolute",
                top: "60%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                height: "56.25vw",
                minHeight: "100vh",
                minWidth: "177.77vh",
                objectFit: "cover",
                pointerEvents: "none",
              }}
            ></iframe>

            <iframe
              className="block md:hidden"
              src="https://player.vimeo.com/video/1145548304?autoplay=1&loop=1&muted=1&controls=0&background=1"
              title="Mobile Hero Video"
              frameBorder="0"
              allow="autoplay; fullscreen"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                pointerEvents: "none",
              }}
            ></iframe> 
            */}
          </>
        )}
      </div>

      {/* ✅ Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
